import type { QuerySort } from '#layers/collection-query/public';
import type { LayoutSortingState } from '#layers/listing/types/layout';
import { useWorkspaceSchemaStore } from '#layers/workspace/public';

export function useConvertLayoutSortingStateToQuerySort() {
	const { findPrimitiveFieldById } = useWorkspaceSchemaStore();

	function convert(layoutSortingState: LayoutSortingState | undefined): QuerySort | undefined {
		if (!layoutSortingState || layoutSortingState.length === 0) {
			return;
		}

		const querySort: QuerySort = layoutSortingState.map((sortItem) => {
			const field = findPrimitiveFieldById(sortItem.fieldId);

			if (!field) {
				return null;
			}

			return {
				[field.apiName]: { direction: sortItem.direction },
			};
		}).filter(Boolean) as QuerySort;

		return querySort.length > 0 ? querySort : undefined;
	}

	return {
		convert,
	};
}
